var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{attrs:{"id":"components-layout-side"}},[_c('a-layout-header',{staticClass:"header",attrs:{"theme":"light"}},[_c('Header')],1),_c('a-layout-content',{staticClass:"layout-content"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"main"},[_c('router-view')],1)])]),_c('a-layout-footer',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }